import {
  OPEN_SEARCHBOX_MODAL,
  CLOSE_SEARCHBOX_MODAL
} from "../constants/actionTypes";
import { setCheckinDate, setCheckoutDate } from "./datesActions";

export const openSearchboxWin = ({ payload }) => dispatch => {
  dispatch({ type: OPEN_SEARCHBOX_MODAL });
  dispatch(setCheckinDate(payload && payload.newCheckInDate));
  dispatch(setCheckoutDate(payload && payload.newCheckOutDate));
};

export const closeSearchboxWin = () => {
  return {
    type: CLOSE_SEARCHBOX_MODAL
  };
};



// WEBPACK FOOTER //
// ./src/actions/generalActions.js